import React from "react";
import { useParams, Link } from "react-router-dom";
import { getReviewById } from "./api";
import LogViewer from "../tasks/LogViewer";
import JSONViewer from "../tasks/JSONViewer";

const API_URL = process.env.REACT_APP_API_URL;
const fetchConfig = {
  credentials: "include",
  headers: { "Content-Type": "application/json", Accept: "application/json" },
};

const FeedbackView = () => {
  const [feedback, setFeedback] = React.useState(false);
  const [course, setCourse] = React.useState(false);
  const [user, setUser] = React.useState(false);
  const [task, setTask] = React.useState(false);
  const [showLogs, setShowLogs] = React.useState(false);
  const [showJSON, setShowJSON] = React.useState(false);

  const { id } = useParams();
  React.useEffect(() => {
    const fetchFeedback = async () => {
      const feedback = await getReviewById(id);
      setFeedback(feedback.review);
      setCourse(feedback.course);
      setUser(feedback.user);
      setTask(feedback.task);
    };
    fetchFeedback();
  }, []);
  console.log("Feedback:", feedback);
  Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + h * 60 * 60 * 1000);
    return this;
  };

  const [reply, setReply] = React.useState("");

  const magicWrite = async () => {
    const metadata = {
      type: "Course Review",
      user_name: user.name,
      user_email: user.email,
      course_title: course.title,
      feedback: feedback.content,
      course_rating: feedback.rating.toString() + "/5",
      support_instructions: reply,
    };
    console.log("Magic Write Metadata:", metadata);
    const res = await fetch(`${API_URL}/support/magic_write`, {
      ...fetchConfig,
      method: "POST",
      body: JSON.stringify({ metadata }),
    });
    console.log("Magic Write Response:", res);
    const data = await res.json();
    console.log("Magic Write Data:", data);
    setReply(data.response);
  };

  const sendEmail = async () => {
    addMessage();

    const req = {
      recipient: user.email,
      subject: "Support Studizy",
      body: reply,
      push_token: feedback.push_token,
    };
    const res = await fetch(`${API_URL}/support/send_email`, {
      ...fetchConfig,
      method: "POST",
      body: JSON.stringify(req),
    });
    handleStatusChange("Handled");
    console.log("Email Response:", res);
  };
  const addMessage = async () => {
    const newMsg = {
      sender: "Support",
      content: reply,
    };
    setFeedback({
      ...feedback,
      messages: feedback.messages
        ? [
            ...feedback.messages,
            {
              sender: "Support",
              content: reply,
            },
          ]
        : [
            {
              sender: "Support",
              content: reply,
            },
          ],
    });
    const res = await fetch(
      `${API_URL}/support/add_message/course_reviews/${feedback._id}`,
      { ...fetchConfig, method: "POST", body: JSON.stringify(newMsg) }
    );
    setReply("");

    const data = await res.json();
    console.log("Add Message Response:", data);
  };

  const handleStatusChange = async (status) => {
    const res = await fetch(
      `${API_URL}/support/update_status/course_reviews/${feedback._id}/${status}`,
      { ...fetchConfig, method: "GET" }
    );
    const data = await res.json();
    console.log("Status Change Response:", data);
    setFeedback({ ...feedback, status: status });
  };

  return (
    <div>
      <div className="columns">
        <div className="column is-6">
          <div className="is-flex is-justify-content-space-between">
            <h1>
              Course Review View (created_at)
              <span className="tag is-primary">
                {feedback.is_premium ? "Premium User" : "Free User"}
              </span>
              <span className="tag is-secondary ml-2">
                {feedback.push_token ? "PUSH" : "EMAIL"}
              </span>
            </h1>
            {/* Select status dropdown */}
            <div className="select">
              <select
                value={feedback.status || "Unhandled"}
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option>Unhandled</option>
                <option>Handled</option>
                <option>Waiting</option>
                <option>Closed</option>
              </select>
            </div>
          </div>
          <h3 className="subtitle is-3">{feedback?.content}</h3>
        </div>
        <div className="column is-6">
          <h1>User ({user?._id})</h1>
          <h3 className="subtitle is-3">
            {user?.name} - {user?.email}
          </h3>
        </div>
      </div>
      <div className="columns">
        <div className="column is-6">
          {feedback.messages &&
            feedback.messages.map((message) => (
              <div
                className="column box is-7 has-background-grey-dark p-4"
                style={{
                  float: message.sender === "Support" ? "right" : "left",
                }}
              >
                <p className="subtitle is-5">{message.content}</p>
              </div>
            ))}
          <h1>Reply</h1>

          <textarea
            name=""
            id=""
            className="input"
            style={{ minHeight: 300 }}
            value={reply}
            onChange={(e) => setReply(e.target.value)}
          ></textarea>
          <div className="is-flex is-justify-content-space-between">
            <button
              className="button is-primary mt-3 is-medium"
              onClick={() => magicWrite()}
            >
              Magic Write
            </button>
            <button
              className="button is-grey mt-3 is-medium"
              onClick={() => sendEmail()}
            >
              Send
            </button>
          </div>

          {showJSON ? (
            <JSONViewer
              url={`https://studizycloud.blob.core.windows.net/courses/${course?._id}/chapters.${showJSON}.json?sv=2022-11-02&ss=bfqt&srt=o&sp=rwdlacupitfx&se=2025-12-25T21:40:26Z&st=2024-12-25T13:40:26Z&spr=https&sig=5Zl1tHxr%2BfNDWtmdRKWngqw0Bd5R1ZJFGQDp6IdlxkQ%3D`}
              close={() => setShowJSON(false)}
              idx={showJSON.split(".")[0]}
              label={showJSON.split(".")[1]}
            />
          ) : null}
          {showLogs ? (
            <LogViewer
              url={`https://studizycloud.blob.core.windows.net/logs/${task?._id}_orchestrator.log?sv=2022-11-02&ss=bfqt&srt=o&sp=rwdlacupitfx&se=2025-12-25T21:40:26Z&st=2024-12-25T13:40:26Z&spr=https&sig=5Zl1tHxr%2BfNDWtmdRKWngqw0Bd5R1ZJFGQDp6IdlxkQ%3D`}
            />
          ) : null}
        </div>
        <div className="column is-6">
          <h1>Course ({course._id})</h1>
          <Link to={`/course/${course._id}`} className="title is-3">
            {course?.title}{" "}
            <span className="tag">{course?.premium ? "PREMIUM" : "Free"}</span>
          </Link>
          <a
            className="tag is-primary mb-3 is-large"
            href={course?.origin_url}
            target="_blank"
          >
            Open PDF
          </a>
          <button
            className="tag is-danger mb-3 ml-2 is-large"
            onClick={() => setShowLogs(!showLogs)}
          >
            {showLogs ? "Hide" : "Show"} Logs
          </button>
          <ul>
            <li>Pages : {task?.original_pages_length}</li>
            <li>Status : {task?.status}</li>
            <li>
              Created at :{" "}
              {new Date(task?.created_at).addHours(1).toLocaleDateString() +
                " " +
                new Date(task?.created_at).addHours(1).toLocaleTimeString()}
            </li>
            <li>Errors: {task?.errors ? task.errors.length : 0}</li>
            <br />
            {task?.errors?.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
          <hr />
          <h1>Chapters</h1>
          <div className="columns is-multiline mt-3" style={{ gap: 20 }}>
            {course?.chapters?.map((chapter, idx) => (
              <div
                className="card has-background-grey-dark column is-5"
                key={chapter._id}
              >
                <div className="card-content">
                  <h1 className="title is-4 mb-2">{chapter.title}</h1>
                  <p>Pages: {chapter?.page_range}</p>

                  <div style={{ display: "block !important" }}>
                    <p className="has-text-grey-light">
                      - Notes: {chapter.sub_chapters ? "True" : "False"}
                    </p>
                    <p className="has-text-grey-light">
                      - Podcast: {chapter.podcast?.progress}%
                    </p>
                    <p className=" has-text-grey-light">
                      - Quiz: {chapter.questions ? "True" : "False"}
                    </p>
                  </div>
                  <button
                    onClick={() => setShowJSON(`${idx}.questions`)}
                    className="tag is-primary mb-3 mt-3 is-medium"
                  >
                    Open Quizz
                  </button>
                  <button
                    onClick={() => setShowJSON(`${idx}.sub_chapters`)}
                    className="tag is-primary ml-3 mt-3 is-medium"
                  >
                    Open Notes
                  </button>

                  <audio controls="controls" style={{ width: "100%" }}>
                    <source src={chapter.podcast?.url} type="audio/mpeg" />
                  </audio>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackView;
